import Header from "../Header";
import Footer from "../Footer";
import Breadcrumbs from "../Breadcrumbs";import BannerImg from "../assets/Images/banner-1920x450.png";

import BottomLogoImg from "../assets/Images/bottom-logo.png";
import LineImg from "../assets/Images/line.png";
import 'font-awesome/css/font-awesome.min.css';
import "./Enforcement.scss";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const EnforcementPage = () => {
  const { t } = useTranslation();

  return (
    <>
      <Header />
      <div className="banner">
        <img src={BannerImg} alt="" />
        <div className="banner_title">
          <h1 className="banner-main-title">{t("arbitration_fees_page_header")}</h1>
          <p className="banner-subtitle">{t("enforcement")}</p>
        </div>
      </div>
      <Breadcrumbs>
        <Link>{t("breadcrumbs_enforcement_page_link1")}</Link>
        <span>{t("breadcrumbs_enforcement_page_span")}</span>
        <Link>{t("breadcrumbs_enforcement_page_link2")}</Link>
      </Breadcrumbs>
      <main className="enforcement-main-container">
        <section className="enforcement-intro">
          <p className="enforcement-text">{t("enforcement_text1")}</p>
          <p className="enforcement-text">{t("enforcement_text2")}</p>
        </section>

        <section className="documents-grid">
          <div className="document-item">
            <div className="document-header">
              <i className="fa fa-folder-o document-icon"></i>
              <strong className="document-title">{t("enforcement_text3")}</strong>
            </div>
            <div className="document-links">
              <a href="https://www.hkarbsoc.org.hk/Precedent_Originating_Summons.pdf" className="btn btn-pdf" target="_blank" rel="noopener noreferrer">.PDF</a>
              <a href="https://www.hkarbsoc.org.hk/Precedent_Originating_Summons.docx" className="btn btn-doc" target="_blank" rel="noopener noreferrer">.DOC</a>
            </div>
          </div>

          <div className="document-item">
            <div className="document-header">
              <i className="fa fa-folder-o document-icon"></i>
              <strong className="document-title">{t("enforcement_text4")}</strong>
            </div>
            <div className="document-links">
              <a href="https://www.hkarbsoc.org.hk/Precedent_Affirmation.pdf" className="btn btn-pdf" target="_blank" rel="noopener noreferrer">.PDF</a>
              <a href="https://www.hkarbsoc.org.hk/Precedent_Affirmation_.docx" className="btn btn-doc" target="_blank" rel="noopener noreferrer">.DOC</a>
            </div>
          </div>

          <div className="document-item">
            <div className="document-header">
              <i className="fa fa-folder-o document-icon"></i>
              <strong className="document-title">{t("enforcement_text5")}</strong>
            </div>
            <div className="document-links">
              <a href="https://www.hkarbsoc.org.hk/Precedent_Order.pdf" className="btn btn-pdf" target="_blank" rel="noopener noreferrer">.PDF</a>
              <a href="https://www.hkarbsoc.org.hk/Precedent_Order.docx" className="btn btn-doc" target="_blank" rel="noopener noreferrer">.DOC</a>
            </div>
          </div>
        </section>
       
        <section className="enforcement-line-section">
          <img src={LineImg} alt="" className="line-image" />
        </section>
      </main>

      <section className="temporary">
        <img src={BottomLogoImg} alt="" />
      </section>
      <Footer />
    </>
  );
};

export default EnforcementPage;
